module.exports = "/_next/static/images/133a5cf7e114da715e9eaef8f11857a7-card.png.webp";